import React, { useState } from "react";
import certificationsimage9 from "../assets/img/APEDA_RCMC_EFPL_page-0001.jpg";
import certificationsimage10 from "../assets/img/REPC_RCME_EFPL_001.jpg";

export const CertiCard = () => {
  const certificationData = [
    { id: 1, thumbnails: certificationsimage9, certititle: "APEDA Certificate", fullImages: certificationsimage9 },
    { id: 2, thumbnails: certificationsimage10, certititle: "REPC Certificate", fullImages: certificationsimage10 },
  ];

  const [openCertificates, setOpenCertificates] = useState(null);
  const [zoom, setZoom] = useState(1); // state to manage zoom level

  const closesModal = () => {
    setOpenCertificates(null);
    setZoom(1); // Reset zoom when modal is closed
  };

  // Function to handle when a thumbnail is clicked
  const handleCertificatesClick = (id) => {
    if (openCertificates === id) {
      setOpenCertificates(null);  // Close if clicked on the same image
    } else {
      setOpenCertificates(id);  // Open the new certificate
    }
  };

  // Function to handle when clicking outside the image (on the overlay)
  const handleClosesClick = (e) => {
    if (e.target.classList.contains('certioverlay')) {
      setOpenCertificates(null);
      setZoom(1); // Reset zoom when clicking outside
    }
  };

  // Functions for zooming in and out
  const zoomIn = () => {
    if (zoom < 3) { // Limiting max zoom level
      setZoom(zoom + 0.5);
    }
  };

  const zoomOut = () => {
    if (zoom > 1) { // Limiting min zoom level
      setZoom(zoom - 0.5);
    }
  };

  return (
    <>
      {/* Displaying certificate thumbnails */}
      {certificationData.map((certi) => (
        <div
          key={certi.id}
          className="certifications-image3"
          onClick={() => handleCertificatesClick(certi.id)}
        >
          <img src={certi.thumbnails} alt={`Certificate ${certi.id}`} />
          <h3>{certi.certititle}</h3>
        </div>
      ))}

      {/* Full Image Modal */}
      {openCertificates !== null && (
        <div className="certioverlay" onClick={handleClosesClick}>
          <span className="certifications-close" onClick={closesModal}>
            &times;
          </span>
          <div className="certificate-full-image">
            <img
              src={certificationData[openCertificates - 1].fullImages}
              alt={`Full Certificate ${openCertificates}`}
              style={{ transform: `scale(${zoom})`, transition: "transform 0.3s ease" }} // Apply zoom
            />
            <h3>{certificationData[openCertificates - 1].certititle}</h3>
            <div className="zoom-controls">
              <button onClick={zoomIn}>+</button>
              <button onClick={zoomOut}>-</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
